'use client';

import { ListOption, listOptionTag } from '@ni/nimble-components/dist/esm/list-option';
import { wrap } from '../utilities/react-wrapper';

export { listOptionTag };
export { type ListOption };
export const NimbleListOption = wrap(ListOption);
